namespace Matrix.Data {
    export interface SecurityPublishReviewRow {
        RowId?: number;
        IsInboxChange?: number;
    }

    export namespace SecurityPublishReviewRow {
        export const idProperty = 'RowId';
        export const localTextPrefix = 'Data.SecurityPublishReview';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            RowId = "RowId",
            IsInboxChange = "IsInboxChange"
        }
    }
}
